import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-informacion-banca',
  templateUrl: './informacion-banca.component.html',
  styleUrls: ['./informacion-banca.component.scss']
})
export class InformacionBancaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  readLocalStorageValue(key) {
    return localStorage.getItem(key);
  }

}
